import { useAuth } from '@/services/auth';
import { ReactNode, useEffect } from 'react';

export interface RouteType {
    path: string;
    tag: string;
    component: ReactNode;
    layout?: any;
    title?: string;
}

export const AuthGuard = ({ children }: { children: ReactNode }) => {
    const { isAnonymous, loginWithRedirect, isLoading } = useAuth();

    useEffect(() => {
        if (isAnonymous && !isLoading) {
            loginWithRedirect({
                redirectUri: `${window.location.origin}`,
                appState: {
                    returnTo: `${window.location.origin}${window.location.pathname}`,
                },
            });
        }
    }, [isAnonymous, loginWithRedirect, isLoading]);

    if (isAnonymous) {
        return null;
    }

    return children;
};
